import {useFilterConfig} from '../../../store/hooks/config'
import {CircularProgress} from '@mui/material'
import DataRefetchOnError from '../../common/DataFetchError/DataRefetchOnError'
import MultiSelectDropdownComponent from '../../common/MulitSelectDropdown/MultiSelectDropdownComponent'
import {DropdownLoadingBox} from '../Jurisdiction/JurisdictionStyle'
import {SharedSubTitle} from '../../common/SharedSubTitleStyle'
import loadingTitles from '../../../appConfig/loadingTitles.config.json'
import PropTypes from 'prop-types'
import {StyledSectionTitle} from '../../AdminPanelStyling'
import {useProjectDetails} from '../../../store/hooks/projectDetails'

const CommunitySupportComponent = ({
  selectedData,
  setFilterValue,
  handleOptionDeletion,
  enabled,
  isCompleted,
  showCustomLabels,
  setCustomLabelDialogProps,
  hasAnyFilters
}) => {
  const {filterDetailsLoading, filterDetailsError, refetchFilterDetailsList} = useProjectDetails()
  const filterConfig = useFilterConfig()

  function refetchHealthAndConditions(event) {
    event.preventDefault()
    refetchFilterDetailsList()
  }

  const renderDropdown = () => {
    if (filterDetailsLoading) {
      return (
        <DropdownLoadingBox>
          <CircularProgress title={loadingTitles.communitySupportBreadcrumb} />
        </DropdownLoadingBox>
      )
    }

    if (!filterDetailsLoading && filterDetailsError) {
      return <DataRefetchOnError onTryAgain={(event) => refetchHealthAndConditions(event)} />
    }

    const communitySupportSection = filterConfig?.data?.find((section) => section.id === '6')
    const communitySupportKeys = communitySupportSection?.filters?.map((filter) => filter.key) || []
    const communitySupportFilters =
      communitySupportSection?.filters.map((filter) => ({
        title: filter.name,
        FILTER_KEY: filter.key,
        FILTER_ID: filter.key,
        IS_ACTIVE: true
      })) || []

    const sortedHealthCondition = communitySupportFilters.sort((a, b) => {
      if (a.title < b.title) return -1
      if (a.title > b.title) return 1
      return 0
    })

    // Predicate to check if filter belongs to Community Support section
    const isCommunitySupportFilter = (filter) => communitySupportKeys.some((key) => filter.FILTER_KEY?.startsWith(key))

    // Filter selectedData to only include Community Support filters
    const selectedCommunitySupportFilters = selectedData?.filter(isCommunitySupportFilter) || []

    // Wrapper to merge with other filter sections
    const handleCommunitySupportChange = (newFilters) => {
      const otherFilters = selectedData?.filter((filter) => !isCommunitySupportFilter(filter)) || []
      setFilterValue([...otherFilters, ...newFilters])
    }

    return (
      <MultiSelectDropdownComponent
        selectAllTitle='Select All'
        dropDownTitle='Select'
        inputAndPreviewTitle='Community Support and Location'
        dropDownModifiedTitle='Selected'
        dropDownData={sortedHealthCondition}
        val={selectedCommunitySupportFilters}
        setVal={handleCommunitySupportChange}
        enabled={enabled}
        isCompleted={isCompleted}
        handleOptionDeletion={(type, data, option) => handleOptionDeletion(type, data, option)}
        hasAnyFilters={hasAnyFilters}
        isFilterDropdown={true}
        section='Community Support and Location'
        setCustomLabelDialogProps={setCustomLabelDialogProps}
        showCustomLabels={showCustomLabels}
      />
    )
  }
  return (
    <>
      <StyledSectionTitle variant='h5'>
        {' '}
        What Community Support and Location filters do you want available?{' '}
      </StyledSectionTitle>
      <SharedSubTitle>This is what your client will see when interacting with data on their dashboard</SharedSubTitle>
      {renderDropdown()}
    </>
  )
}

CommunitySupportComponent.propTypes = {
  selectedData: PropTypes.array.isRequired,
  setFilterValue: PropTypes.func.isRequired,
  handleOptionDeletion: PropTypes.func,
  enabled: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  showCustomLabels: PropTypes.bool,
  setCustomLabelDialogProps: PropTypes.func,
  hasAnyFilters: PropTypes.bool
}

export default CommunitySupportComponent
